import { SET_AGGREGATION_CURRENCY, SET_CURRENCY_RATES } from '../constants/actionTypes'
import { API, Auth } from 'aws-amplify'
import { storage } from '../storage'
import { updateAssetTypeSummary } from './assets'
import { updateLiabilityTypeSummary } from './liabilities'
import { initNetWorthSummary } from './networth'


export function initCurrencyInfo(aggregationCurrency) {
  return async dispatch => {
    const init = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      }
    };
    const currencyRates  = await API.get("CurrencyRatesGateway", "/currency_rates", init);
    dispatch({ type: SET_CURRENCY_RATES, currencyRates })
  }
}

export const setAggregationCurrency = aggregationCurrency => ({
  type: SET_AGGREGATION_CURRENCY,
  aggregationCurrency
})

export const setCurrencyRates = currencyRates => ({
  type: SET_CURRENCY_RATES,
  currencyRates
})

export function saveAggregationCurrency(aggregationCurrency) {
  return async (dispatch, getState) => {
    const init = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      },
      body: { aggregationCurrency }
    }
    await API.put('UserInfoGateway', '/user_info', init)
    storage.setItem('aggregationCurrency', aggregationCurrency)
    dispatch(setAggregationCurrency(aggregationCurrency))
    const { assetInfo, liabilityInfo, currencyInfo } = getState()
    const updatedCurrencyInfo = { ...currencyInfo, aggregationCurrency }
    await Promise.all([
      dispatch(updateAssetTypeSummary(assetInfo.assetSummary, updatedCurrencyInfo)),
      dispatch(updateLiabilityTypeSummary(liabilityInfo.liabilitySummary, updatedCurrencyInfo)),
      dispatch(initNetWorthSummary(updatedCurrencyInfo)),
    ])
  }
}
